<div class="checklist">
    <div [appOptionalWorkflow]="optionalWorkflowCondition" [initialExpanded]="true">
        @if (isNewElectricalChecklist) {
            <lib-sol-checklist-electrical></lib-sol-checklist-electrical>
        } @else {
            <lib-sol-checklist-part-one></lib-sol-checklist-part-one>
            <lib-sol-checklist-part-two></lib-sol-checklist-part-two>
            <lib-sol-checklist-part-three></lib-sol-checklist-part-three>
        }
    </div>
</div>      